<template>
  <page :head-text="$t('discover.head_title')" head-uppercase :can-scroll="true">
    <discover-items v-if="rmdSizes[0]" :data="rmdSizes[0].sizes" @show-item="onShowItem" />
    <bottom-nav
      :has-rmd-sizes="hasRmdSizes"
      :fixed="true"
      :active-page="activePage"
      @changed="$emit('update:active-page', $event)"
    />
    <!-- Prompt -->
    <rounded-card
      :height="`80%`"
      :headText="activeItem.name"
      v-if="showPrompt"
      show-right-btn
      class="p-3"
      @set-close-status="cancel"
    >
      <div class="flex text-center w-full flex-col flex-grow">
        <template>
          <div v-if="noSizes" class="no-data">
            <img :src="require(`@/assets/Discover/error-face.svg`)" class="mr-2" />
            {{ $t('discover.no_rmd_data') }}
          </div>
          <div v-else class="recommend-size-container">
            <discover-items-ruler v-if="activeItem.ratio !== null" :ratio="activeItem.ratio" />
            <div v-if="activeItem.ratio < 0.5">
              <div
                v-if="activeItem.min.size"
                class="size-blocks min"
                :class="{ active: activeItem.ratio < 0.25 }"
                :data-content="$t('discover.rmd_size')"
              >
                {{ activeItem.min.size }}
              </div>
              <div
                v-if="activeItem.max.size"
                class="size-blocks max"
                v-html="activeItem.max.size"
                :class="{ active: activeItem.ratio >= 0.25 }"
                :data-content="$t('discover.rmd_size')"
              >
                {{ activeItem.max.size }}
              </div>
            </div>
            <div v-else>
              <div
                v-if="activeItem.min.size"
                class="size-blocks min"
                :class="{ active: activeItem.ratio <= 0.75 }"
                :data-content="$t('discover.rmd_size')"
              >
                {{ activeItem.min.size }}
              </div>
              <div
                v-if="activeItem.max.size"
                class="size-blocks max"
                v-html="activeItem.max.size"
                :class="{ active: activeItem.ratio > 0.75 }"
                :data-content="$t('discover.rmd_size')"
              >
                {{ activeItem.max.size }}
              </div>
            </div>
          </div>
          <div v-if="activeItem.product_url" class="mt-auto mx-auto w-full flex justify-center">
            <c-button
              :confirmedStatus="activeItem.ratio !== null"
              class="my-10 text-white"
              @click="handlePurchase(activeItem.product_url)"
            >
              {{ $t('discover.buy_item') }}
            </c-button>
          </div>
        </template>
      </div>
    </rounded-card>
  </page>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import { EVENTS as HW_EVENTS } from '@/events/hardware';
import page from '@/mixins/page';
import showAvatar from '@/mixins/show-avatar';
import scanImg from '@/assets/common/menu-scan.svg';
import RoundedCard from '@/components/common/RoundedCard.vue';
import Page from '@/components/DefaultCloudzet/HomePage/Page.vue';
import BottomNav from '@/components/DefaultCloudzet/HomePage/BottomNav.vue';
import DiscoverItems from '@/components/DefaultCloudzet/HomePage/DiscoverItems.vue';
import DiscoverItemsRuler from '@/components/DefaultCloudzet/HomePage/DiscoverItemsRuler.vue';
import CButton from '@/components/common/CButton.vue';

export default {
  mixins: [page, showAvatar],
  components: {
    Page,
    BottomNav,
    DiscoverItems,
    DiscoverItemsRuler,
    RoundedCard,
    CButton,
  },
  props: {
    rmdSizes: Object,
    profile: Object,
    recordToShow: Boolean,
    hasRmdSizes: Boolean,
    activePage: {
      type: String,
      default: 'measurement',
    },
  },
  data() {
    return {
      showPrompt: false,
      activeItem: null,
    };
  },
  methods: {
    ...mapActions('app', ['launchQrScan']),
    handleMenuItem(menuItem) {
      if (menuItem.pageName === 'user-setting') {
        this.$emit('menu', { ...menuItem, directOpen: true });
      } else {
        this.$emit('menu', menuItem);
      }
    },
    handlePurchase(url) {
      if (!this.appReady) {
        window.open(url);

        return;
      }
      this.$events.emit(HW_EVENTS.OPEN_LINK_IN_BROWSER, url);
    },
    cancel() {
      this.showPrompt = false;
    },
    onShowItem(item) {
      this.activeItem = item;
      this.showPrompt = true;
    },
  },
  computed: {
    ...mapGetters('user', ['latestBodyRecord']),
    ...mapState('app', ['appReady']),
    scanQrMenuItem() {
      return {
        img: scanImg,
        name: this.$t('homePage.scan_to_login'),
      };
    },
    menuList() {
      return [
        // 'avatar-shader',  TODO: add this
        'user-setting',
      ];
    },
    noSizes() {
      return !(this.activeItem.min?.size && this.activeItem.max?.size);
    },
  },
};
</script>

<style lang="scss" scoped>
.profile-wrapper {
  color: #262626;
}

.no-data {
  text-align: center;
  color: #d12c2d;
  margin: 2rem auto;
  justify-content: center;
  display: flex;
  align-items: center;
  line-height: 1;
  font-size: 11px;
}

.brand-logo {
  max-height: 100px;
  margin: auto;

  img {
    height: 100%;
  }
}

.recommend-size-container {
  @apply flex flex-col;
  margin-top: 0.5rem;
  margin-bottom: 2rem;
  padding-left: 1.5rem;
  padding-right: 3.75rem;
  position: relative;

  .size-blocks {
    margin-bottom: 0.875rem;
    background-color: #5959591a;
    border-radius: 8px;
    padding: 1rem;
    text-align: left;
    position: relative;

    &:before {
      content: '';
      display: block;
      position: absolute;
      right: -13px;
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 7.5px 0 7.5px 10px;
      border-color: transparent transparent transparent #2245ff;
      transform: scale(0.6);
      opacity: 0.25;
      top: 35%;
    }

    &.active {
      // background: linear-gradient(to right white 0%, #A7FED9 100%);
      background: linear-gradient(to right, white 1%, #a7fed970 100%);
      border: 2px solid #2245ff;
      font-weight: 600;

      &:before {
        transform: scale(1);
        right: -17px;
        opacity: 1;
      }

      &:after {
        content: attr(data-content);
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        display: flex;
        padding: 1rem;
        top: 0;
        justify-content: flex-end;
        align-items: center;
        font-size: 12px;
        color: #595959;
        font-weight: 500;
      }
    }
  }
}
</style>
